import React, { forwardRef } from 'react';
import { Chart } from '../../../../../../CommonComponents/OPL/charts/Chart';
import { useRetirementChart } from './useRetirementChart';
import { RefObjectForHighchartsReact } from '../../../../../../CommonComponents/OPL/charts/Chart.types';
import { RetirementAssetsChartDTO } from './RetirementChart.meta';

interface Props {
  isCurrentPlan: boolean;
  data: RetirementAssetsChartDTO;
  isPrint?: boolean;
}

export const RetirementChart = forwardRef<RefObjectForHighchartsReact, Props>((props, ref) => {
  const { chartConfig } = useRetirementChart(props);

  return <Chart ref={ref} options={chartConfig} />;
});
